import {
  lookupManagementComponentOptions,
  vsComponentName as lookupManagementComponentName,
} from "./lookupManagement";
import {
  LookupModalService,
  vsServiceName as LookupModalServiceName,
  vsComponentName as lookupModalComponentName,
  lookupModalComponentOptions,
} from "./lookupModal";
import {
  LookupEditModalService,
  vsServiceName as LookupEditModalServiceName,
  vsComponentName as lookupEditModalComponentName,
  lookupEditModalComponentOptions,
} from "./lookupEditModal";
import {
  vsComponentName as lookupManagementDetailsComponentName,
  lookupDetailComponentOptions,
} from "./lookupManagement/Details";
import angular from "angular";

export const vsModuleName = "records.lookup";

angular
  .module(vsModuleName, [])
  .component(lookupManagementComponentName, lookupManagementComponentOptions)
  .component(lookupManagementDetailsComponentName, lookupDetailComponentOptions)
  .service(LookupModalServiceName, LookupModalService)
  .service(LookupEditModalServiceName, LookupEditModalService)
  .component(lookupModalComponentName, lookupModalComponentOptions)
  .component(lookupEditModalComponentName, lookupEditModalComponentOptions);
